import React, { Component } from 'react';
import { Button, InputGroup, FormControl } from 'react-bootstrap';
import ReactTable from "react-table";
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faEye, faShare, faSearch } from '@fortawesome/free-solid-svg-icons';
import 'react-table/react-table.css';

export default class TBLEntregadores extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: this.props.data,
            data_original: this.props.data
        };

        this.columns = [
            {
                Header: 'Status',
                accessor: 'status',
                Cell: props => (<span style={{ backgroundColor: this.setBgColor(props.value) }}>{props.value.toUpperCase()}</span>),
                className: "center"
            }, {
                Header: 'Nome',
                accessor: 'nome',
                className: "center"
            }, {
                Header: 'CPF',
                accessor: 'cpf',
                className: "center"
            }, {
                Header: 'RG',
                accessor: 'rg',
                className: "center"
            }, {
                Header: 'Endereço',
                accessor: 'endereco',
                Cell: props => props.value ? (<span>{props.value.rua} {props.value.numero}, {props.value.bairro}</span>) : (<span></span>),
                width: 280,
            }, {
                Header: 'Telefone',
                accessor: 'telefone',
                className: "center"
            }, {
                Header: 'Email',
                accessor: 'usuario',
                Cell: props => (<span>{props.value.email}</span>),
                className: "center",
            }, {
                Header: "Ações",
                Cell: row => this.props.isModoDespacho ? (
                    <div>
                        <Button size="sm" style={{ marginRight: 4 }} variant="warning"
                            onClick={() => this.gerenciarAcoes("despachar_entregador", row.row._original)}><FontAwesomeIcon icon={faShare}></FontAwesomeIcon>
                        </Button>
                    </div>) : (
                        <div>
                            <Button size="sm" style={{ marginRight: 4 }}
                                onClick={() => this.gerenciarAcoes("editar", row.row._original)}><FontAwesomeIcon icon={faEye}></FontAwesomeIcon>
                            </Button>
                            <Button size="sm" variant="danger"
                                onClick={() => this.gerenciarAcoes("deletar", row.row._original)}><FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
                            </Button>
                        </div>
                    ),
                className: "center"
            }];
    }

    setBgColor = (status) => {
        if (status === "disponivel") {
            return "#b0e0a8";
        } else if (status === "em_atendimento") {
            return "#f0f69f";
        } else {
            return "#f3c1c6";
        }
    }

    gerenciarAcoes = (tipo, dados) => {
        if (tipo === "editar") {
            this.props.dataCallback(tipo, dados);
        } else if (tipo === "deletar") {
            this.props.dataCallback(tipo, dados);
        } else if (tipo === "despachar_entregador") {
            this.props.dataCallback(tipo, dados);
        } else {
            return;
        }

    }

    pesquisarEntregador = (value) => {
        if (value) {
            const entregadores = this.state.data;
            this.setState({ data: entregadores.filter(e => e.nome.toLowerCase().includes(value.toLowerCase())) });
        } else {
            this.setState({ data: this.state.data_original });
        }
    }

    render() {
        return (
            <div>
                {this.props.isModoDespacho ? (
                    <InputGroup>
                        <InputGroup.Prepend>
                            <InputGroup.Text>
                                <FontAwesomeIcon icon={faSearch}></FontAwesomeIcon>
                            </InputGroup.Text>
                        </InputGroup.Prepend>
                        <FormControl
                            placeholder="Pesquisar entregador"
                            onChange={e => this.pesquisarEntregador(e.target.value)}
                        />
                    </InputGroup>
                ) : null}
                <ReactTable
                    data={this.props.isModoDespacho ? this.state.data : this.props.data}
                    columns={this.columns}
                    resizable={false}
                    showPagination={this.props.showPagination}
                    defaultPageSize={10}
                    previousText='Anterior'
                    nextText='Próximo'
                    loadingText='Carregando entregadores...'
                    noDataText='Nenhum entregador encontrado!'
                    pageText='Página'
                    ofText='de'
                    rowsText='linhas'
                />
            </div>
        );
    }
}

TBLEntregadores.propTypes = {
    data: PropTypes.array,
    showPagination: PropTypes.bool,
    numRows: PropTypes.number,
    dataCallback: PropTypes.func,
    isModoDespacho: PropTypes.bool,
}
